export default __webpack_public_path__ + "static/media/ico-04.928bff21.png";